import qs from 'qs';

export type CalculatorQueryProperty =
  | 'house'
  | 'townhouse'
  | 'apartment'
  | 'unit';

export type CalculatorQueryUsage = 0.2 | 0.4 | 0.6 | 0.8;

export type CalculatorQuerySystemSize = 1.65 | 2.2 | 3.3 | 4.4 | 5.22 | 6.05;

export interface CalculatorQueryData {
  postcode?: number;
  // houseStructure?: CalculatorQueryProperty;
  mostUsage?: CalculatorQueryUsage;
  bill?: number;
  // systemSize?: CalculatorQuerySystemSize;
}

/**
 * Parse the query string of a given URL for the calculator values and convert
 * into an object.
 * @param url URL to parse the querystring of
 */
export const parse = (
  postcode?: string,
  mostUsage?: string,
  bill?: number,
  url: string = window.location.search
): CalculatorQueryData | false => {

  if (!url) return false;

  let query = url;
  if (url.startsWith('?')) query = url.slice(1);

  const data = qs.parse(query);
  const parsed: CalculatorQueryData = {};

  if (postcode || data.postcode) {
    parsed.postcode = postcode || data.postcode;
  }
  if (data.mostUsage) {
    parsed.mostUsage = parseFloat(mostUsage || data.mostUsage) as CalculatorQueryUsage;
  }
  if (data.bill) {
    parsed.bill = bill || data.bill
  }

  return parsed;
};